<template>
  <div class="card">
    <div class="card-header">Market Aggregates (Avg.)</div>
    <pulse-loader
      v-if="loadingTable"
      class="mt-5 text-center"
    ></pulse-loader>
    <table class="table table-hover" v-else>
      <thead>
        <tr>
          <th scope="col">Name</th>
          <th scope="col">Value</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(data, index) in datalist" :key="index">
          <td>{{ index }}</td>
          <td>{{ data.toFixed(2) }}</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import Vue from "vue";
import PulseLoader from "vue-spinner/src/PulseLoader.vue";

export default {
  data: function () {
    return {
      datalist: [],
      fetchedData: null,
      base_url:
        process.env.NODE_ENV === "production"
          ? "https://apidfl.bicm.ac.bd"
          : "http://localhost:8000",
          loadingTable:1
    };
  },
  components: {
    PulseLoader,
  },
  methods: {
    loadGraphData() {
      Vue.axios
        .get(this.base_url + "/api/monthly-market-aggregates?timestamp=" + new Date().getTime())
        .then((response) => {
          this.datalist = response.data;
                  this.loadingTable = 0

        });
    },
  },
  mounted() {
    this.loadGraphData();
  },
};
</script>

<style></style>
